// extracted by mini-css-extract-plugin
export var cartIcon = "_pq-0";
export var cartIconContainer = "_pq-1";